import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './equipamentoAlocacaoForm';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaUnidade, getListaVeiculo
} from './equipamentoAlocacaoActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';
import consts from '../consts';

class EquipamentoAlocacao extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaUnidade();
		this.props.getListaVeiculo();
	}
	
	componentWillUnmount() {
	
	}

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
	
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ data_ocorrencia: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()) });
								}} />
						</Grid>
					</Row>

				</ContentCardHeader>
				<ContentCardBody>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Número</Th>
								<Th alignCenter>Nome</Th>
								<Th alignCenter>Local</Th>
								<Th alignCenter>Início da Alocação</Th>
								<Th alignCenter>Fim da Alocação</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`
										${item.numero}
										${item.nome}
										${item.nome_unidade}{item.placa_veiculo}
										${DateFormat.formatarDataSqlParaTela(item.data_inicio)}
										${DateFormat.formatarDataSqlParaTela(item.data_fim)}
									`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{item.numero}</Td>
									<Td alignCenter>{item.nome}</Td>
									<Td alignCenter>{item.nome_unidade}{item.placa_veiculo}</Td>
									<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_inicio)}</Td>
									<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_fim)}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													data_inicio: DateFormat.formatarDataSqlParaTela(item.data_inicio),
													data_fim: DateFormat.formatarDataSqlParaTela(item.data_fim)
												});
												this.props.initForm({
													...item,
													data_inicio: DateFormat.formatarDataSqlParaTela(item.data_inicio),
													data_fim: DateFormat.formatarDataSqlParaTela(item.data_fim)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													data_inicio: DateFormat.formatarDataSqlParaTela(item.data_inicio),
													data_fim: DateFormat.formatarDataSqlParaTela(item.data_fim)
												});
												this.props.initForm({
													...item,
													data_inicio: DateFormat.formatarDataSqlParaTela(item.data_inicio),
													data_fim: DateFormat.formatarDataSqlParaTela(item.data_fim)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.equipamentoAlocacao,
	modoTela: state.equipamentoAlocacao.modoTela,
	lista: state.equipamentoAlocacao.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaUnidade, getListaVeiculo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EquipamentoAlocacao);
